import ChaptersCollection from 'collections/ChaptersCollection'

export default class ModuleModel extends Backbone.Model {

    preinitialize() {
        this.constructor.type = 'module'
        this.constructor.pluralType = 'modules'
    }

    getParent() {
        return this.getGroupModel()
    }

    getChildren() {
        return new ChaptersCollection(
            Backbone.Collection.chapters.where({moduleId: this.id})
        )
    }

    getSiblings() {
        return this.getGroupModel().modules
    }

    getGroupModel() {
        return Backbone.Collection.groups.get(this.get('groupId'))
    }

    getCrumblepathModel() {
        return new Backbone.Model({
            icon: 'module',
            label: this.get('title'),
            level: 'groups',
            path_id: `${this.getGroupModel().id}?module=${this.id}`,
        })
    }

}
